import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APMmFavoriteCourse } from '../../global/builders/ap_mm_favorite_course_builder';
import { IAPMmFavoriteCoursesDatasource } from '../../global/datasources/ap_mm_favorite_course_datasource';

export class APMmFavoriteCoursesQuery implements IQuery {
  private __result: APMmFavoriteCourse[];

  constructor(QueryMediator: IQueryMediator, private ngAPMmFavoriteCoursesDatasource: IAPMmFavoriteCoursesDatasource) {
    QueryMediator.registerQuery(this, ngAPMmFavoriteCoursesDatasource);
  }
  run(): this {
    const favoriteCourses = this.ngAPMmFavoriteCoursesDatasource.values();
    this.__result = _4.map(favoriteCourses, (course: APMmFavoriteCourse) => {
      return { ...course, title: `${course.cd} ${course.title}` };
    });
    return this;
  }
  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPMmFavoriteCoursesQuery', APMmFavoriteCoursesQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_mm_favorite_courses_query.ts